(() => {
  const targets = new Set(['money-back-guarantee', 'return-conditions']);
  function reveal(id) {
    if (!targets.has(id)) return;
    const details = document.getElementById(id);
    if (details?.tagName === 'DETAILS') details.open = true;
  }
  document.addEventListener('click', event => {
    const anchor = event.target.closest('a[href^="#"]');
    if (anchor) reveal(anchor.hash.slice(1));
  }, true);
  window.addEventListener('hashchange', () => reveal(location.hash.slice(1)));
  reveal(location.hash.slice(1));
})();
